export default "__VITE_ASSET__BjEYhyzi__"